<div class="date-range-buttons text-right">
  <button (click)="setDateRange('1d')" [class.selected]="activeRange == '1d'">1 D</button>
  <button (click)="setDateRange('1w')" [class.selected]="activeRange == '1w'">1 W</button>
  <button (click)="setDateRange('1m')" [class.selected]="activeRange == '1m'">1 M</button>
  <button (click)="setDateRange('6m')" [class.selected]="activeRange == '6m'">6 M</button>
  <button (click)="openDatePicker()" [class.selected]="activeRange == 'custom'">Custom</button>
  <input type="text" [showDropdowns]="true" ngxDaterangepickerMd [(ngModel)]="selected" placeholder="Choose date"
    (change)="dateRangeSelected($event)" #datePickerInput style="display: none;" />
</div>